import APIClient from '../../../common/APIClient';
import { displayError, SUCCESS_ALERT, toggleShowAlert, setIsSaving } from '../commonActions';
import { PENDING } from './projectsActions';

const ADD_APPROVER = 'ADD_APPROVER';
const SET_APPROVERS = 'SET_APPROVERS';
const RESET_APPROVERS = 'RESET_APPROVERS';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const addApprover = (approver) => {
  return (dispatch) => {
    dispatch({type: ADD_APPROVER, approver})
  }
}

export const updateApprovers = (approvers) => {
  return (dispatch) => {
    dispatch({type: SET_APPROVERS, approvers});
  }
}

export const resetApprovers = () => {
  return (dispatch) => {
    dispatch({type: RESET_APPROVERS});
  }
}

export const upsertApprovers = (status = PENDING) => {
  return (dispatch, getState) => {
    let approvers = getState().projects.approvers;
    let project = getState().projects.project;
    
    if (approvers.length) {
      approvers = approvers.map((approver, index) => {
        return  {
          approver_id: approver.approver_id, 
          sequence: index + 1,
          status
        }
      })
      dispatch(setIsSaving(true));
  
      client().post(
        '/projects/approvers/batch/upsert', {
          project_id: project.id, 
          approvers
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          dispatch(setIsSaving(false));
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Approvers has been successfully updated"));
        }
      }).catch(error => {
        dispatch(displayError(error));
        dispatch(setIsSaving(false));
      })
    }
  }
}